import { heroStats, quickCards } from '@/mocks/content';

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden bg-gradient-to-b from-orange-100 via-amber-50 to-[#fffbf5]">
      <div className="absolute -top-24 -left-24 w-72 h-72 rounded-full bg-orange-200/50 blur-3xl" aria-hidden="true"></div>
      <div className="absolute top-40 -right-16 w-80 h-80 rounded-full bg-rose-200/40 blur-3xl" aria-hidden="true"></div>

      <div className="relative w-full px-4 md:px-8 pt-28 md:pt-36 pb-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7 animate-fade-up">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/80 border border-orange-200 text-xs md:text-sm text-orange-700">
              <i className="ri-bookmark-3-line" aria-hidden="true"></i>
              版本信息 · 检索思路 · 观看建议
            </span>

            <h1 className="font-heading mt-5 text-3xl md:text-5xl font-bold leading-tight text-stone-900">
              蜜桃成熟时3D完整版
              <br />
              <span className="text-orange-500">到底哪里能看？</span>
            </h1>

            <p className="mt-5 text-base md:text-lg text-stone-600 leading-relaxed max-w-2xl">
              想找<strong className="text-stone-800">未删减</strong>、<strong className="text-stone-800">高清修复</strong>或
              <strong className="text-stone-800">国语中字</strong>版的正片资源，却总被各种版本名词绕晕？本页把不同版本的区别、
              在线播放与迅雷下载的查找思路整理成一份可对照的指南，帮你快速定位到符合自己需求的那一版。
            </p>

            <p className="mt-3 text-sm text-stone-500">
              说明：本站不存放、不提供任何影片文件，仅汇总版本信息与公开的检索方法，并提醒你注意版权与下载安全。
            </p>

            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <a
                href="#versions"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-orange-500 text-white font-medium hover:bg-orange-600 transition-colors whitespace-nowrap"
              >
                先看版本对比
                <i className="ri-arrow-down-line" aria-hidden="true"></i>
              </a>
              <a
                href="#download"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-white border border-stone-300 text-stone-800 font-medium hover:border-orange-400 hover:text-orange-600 transition-colors whitespace-nowrap"
              >
                迅雷下载思路
                <i className="ri-download-2-line" aria-hidden="true"></i>
              </a>
            </div>

            <dl className="mt-9 grid grid-cols-2 sm:grid-cols-4 gap-4 max-w-2xl">
              {heroStats.map((stat) => (
                <div key={stat.label} className="bg-white/80 border border-stone-200 rounded-xl p-4">
                  <div className="flex items-center gap-2 text-orange-500">
                    <i className={`${stat.icon} text-lg`} aria-hidden="true"></i>
                    <dt className="text-xs text-stone-500">{stat.label}</dt>
                  </div>
                  <dd className="font-heading mt-2 text-2xl font-bold text-stone-900">{stat.value}</dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="lg:col-span-5">
            <div className="relative rounded-2xl overflow-hidden border border-orange-200/70 w-full aspect-[4/5] max-w-md mx-auto lg:ml-auto">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20peach%20and%20cream%20toned%20abstract%20cinematic%20scene%20with%20soft%20bokeh%20light%20spots%2C%20flowing%20silk%20texture%2C%20film%20grain%2C%20elegant%20minimal%20artistic%20composition%2C%20orange%20amber%20rose%20color%20palette%2C%20no%20text&width=900&height=1125&seq=peach-hero-01&orientation=portrait"
                alt="温暖蜜桃色调的电影感抽象画面，用于站点首屏配图"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-stone-900/80 to-transparent p-5">
                <p className="text-white font-heading text-lg">一份看片前的地图</p>
                <p className="text-white/80 text-sm mt-1">先搞清版本差异，再决定在哪看、怎么下。</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {quickCards.map((card) => (
            <article key={card.title} className="bg-white border border-stone-200 rounded-xl p-5">
              <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-orange-100 text-orange-600">
                <i className={`${card.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <h3 className="font-heading mt-4 text-base font-semibold text-stone-900">{card.title}</h3>
              <p className="mt-2 text-sm text-stone-600 leading-relaxed">{card.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}